import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Event.scss';
import globalStyles from '../../globals.scss';

const DividedComponents = ({ children }) => (
  <div>
    {children.map((child, index) => (
      <span key={index}>
        {child}
        {index !== children.length - 1 &&
          <div
            className={[
              globalStyles.desktop,
              styles.verticalDivider
            ].join(' ')}
          >
            &nbsp;
          </div>}
      </span>
    ))}
  </div>
);

DividedComponents.propTypes = {
  children: PropTypes.array.isRequired
};

export default DividedComponents;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/DividedComponents.js